import React, { useState } from "react";
import Modal from "@components/modals/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { closeAllModals } from "@store/slices/modalSlice";
import { createFolder } from "@store/thunks/dashboardThunk";
import { toast } from "react-toastify";

const CreateFolder = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isOpen = useSelector((state) => state.modal.createFolder);
  const { selectedProjectId } = useSelector((store) => store.dashboard);
  const [folderName, setFolderName] = useState("");

  // Determine which type of folder to create based on the current URL path
  const getActiveTab = () => {
    if (location.pathname.includes("/superAdmin/ga")) {
      return "GA";
    } else if (location.pathname.includes("/superAdmin/devnagri")) {
      return "devnagri";
    } else {
      // Default to GA if not in a specific section
      return "GA";
    }
  };

  const handleClose = () => {
    setFolderName("");
    dispatch(closeAllModals("createProject"));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const folderDetails = {
      folderName: folderName,
      projectDetailsId: selectedProjectId,
    };
    try {
      const result = await dispatch(createFolder(getActiveTab(), folderDetails));
      if (result.status === 'success') {
        handleClose();
        toast.success("Folder created successfully!");
      } else {
        console.log(result)
        const errorMessage = result.message || "Failed to create folder";
        toast.error(errorMessage);
      }
    } catch (err) {
      console.error("Create project error:", err);
      toast.error("Unexpected error while creating project");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Create New Folder"
      maxWidth="md"
    >
      <div className="bg-white rounded-lg shadow-sm">
        <div className="p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <label
                htmlFor="folderName"
                className="block text-sm font-semibold text-gray-800 tracking-wide"
              >
                Folder Name <span className="text-[#ff6d1e]">*</span>
              </label>
              <div>
                <input
                  id="folderName"
                  type="text"
                  value={folderName}
                  onChange={(e) => setFolderName(e.target.value)}
                  placeholder="Enter folder name"
                  className="w-full px-4 py-3.5 border border-gray-200 rounded-lg bg-white text-gray-800 text-sm placeholder-gray-400 focus:border-[#ff6d1e] focus:ring-2 focus:ring-[#ff6d1e]/20 hover:border-[#ff6d1e]/50 focus:outline-none transition-all duration-200"
                  required
                />
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Choose a unique and descriptive name for your folder
              </p>
            </div>

            <div className="pt-6">
              <div className="flex justify-end gap-3">
                <button
                  type="button"
                  onClick={handleClose}
                  className="px-6 py-2.5 border border-gray-200 text-gray-600 text-sm font-medium rounded-lg hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-all duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-2.5 bg-[#0066cc] border border-[#0066cc] text-white text-sm font-medium rounded-lg hover:bg-[#0052a3] focus:outline-none focus:ring-2 focus:ring-[#0066cc]/20 transition-all duration-200 transform hover:-translate-y-0.5"
                >
                  Create Folder
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default CreateFolder;
